import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%'
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    boxShadow: '0px 1px 0px #E5E5E5',
    boxSizing: 'border-box',
    marginBottom: '5px',
    minHeight: '48px'
  },
  toolbarLeft: {
    display: 'flex',
    alignItems: 'center',
    minWidth: '200px',
    height: '100%',
    borderRight: '1px solid #E2EBF6',
    boxSizing: 'border-box',
    color: '#59758B'
  },
  toolbarTitle: {
    padding: '12px 30px 12px 29px',
    fontWeight: 'bold',
    fontSize: '18px',
    lineHeight: '24px',
    color: '#000000'
  },
  buttonRoot: {
    fontSize: '13px',
    fontWeight: 'bold',
    padding: '3px 20px',
    marginLeft: '10px'
  },
  toolbarRight: {
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingRight: '30px'
  },
  tabsRoot: {
    flex: '1 1 auto',
    backgroundColor: theme.palette.background.paper,
    display: 'flex'
  },
  container: {
    display: 'flex',
    padding: '20px',
    flexDirection: 'column',
    justifyContent: 'space-between',
    overflow: 'auto',
    width: 'auto',
    height: '100%'
  },
  tableCell: {
    fontSize: '13px',
    border: 'none',
    color: '#000000',
    padding: 0
  },
  table: {
    width: '100%',
    [theme.breakpoints.down('sm')]:{
      overflowX: 'scroll',
      display: 'block',
    }
  },
  heading: {
    color: '#071B27',
    fontWeight: 'bold',
    fontSize: '10px',
    fontFamily: 'Fira Sans',
    textTransform: 'uppercase'
  },
  orderIcon: {
    icon: {
      display: 'none'
    }
  },
  arrowCell: {
    padding: '0',
    width: '10px!important',
    margin: '0'
  },
  nameCell: {
    width: '255px',
    fontWeight: 'bold',
    paddingLeft: 10,
    paddingRight: '20px'
  },
  emailCell: {
    width: '248px',
    paddingRight: '20px',
    paddingLeft: 0
  },
  iconButton: {
    padding: '0px 0px 0px 14px',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  title: {
    display: 'inline'
  },
  closeIcon: {
    fontSize: '21px'
  },
  checkOutCell: {
    width: '85px',
    paddingLeft: '5px',
    paddingRight: '20px'
  },
  phoneCell: {
    width: '120px',
    paddingRight: '20px'
  },
  companyCell: {
    width: '200px',
    paddingRight: '20px'
  },
  tableRow: {
    height: '42px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#E2F5F8'
    }
  },
  loader: {
    zIndex: 9999999
  },
  loaderClassName: {
    width: '80px !important',
    height: '80px !important'
  }
}));

export default useStyles;
